export default __webpack_public_path__ + "c174e3bd4b37eee3cc0bddf3dc7920d6.png";